// Independent page composition for Digital Implementation & Delivery.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function DigitalDeliveryPage({ service }) {
  return h(PageFrame, { service, tone: 'split', hero: diagram(service, 'journey') },
    section('Design around the real workflow', split(context(service), scenario(service))),
    section('Make the next step practical', deliverables(service, 'timeline'), { theme: 'ai-wash', className: 'ai-narrow-section' }),
    section(null, split(answer(service), scope()))
  );
};
